import { render, staticRenderFns } from "./QuestionStatus.vue?vue&type=template&id=1331930e&"
import script from "./QuestionStatus.vue?vue&type=script&lang=js&"
export * from "./QuestionStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports